module.exports = __webpack_public_path__ + "img/pic-02.c304c7d2.png";